import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "split",
  standalone: false,
})
export class SplitPipe implements PipeTransform {
  transform(text: string, by: string) {
    if (text == null) return text;
    if (text.trim() == "") return null;

    return text.split(by);
  }
}
